import PersonalInformationLayout from '@/features/onboarding/personal-information/layout';
import ServicesAgreement from '@/features/services-agreement/components/agreement';

const OnboardingServicesAgreementPage = () => {
  return (
    <PersonalInformationLayout>
      <ServicesAgreement next="/onboarding/personal-information" />
    </PersonalInformationLayout>
  );
};
OnboardingServicesAgreementPage.displayName = 'OnboardingServicesAgreementPage';

export default OnboardingServicesAgreementPage;
